import SROnly from './sr-only';

export default SROnly;
